import { render, staticRenderFns } from "./VdBindShop.vue?vue&type=template&id=b29add38&scoped=true"
import script from "./VdBindShop.vue?vue&type=script&lang=ts"
export * from "./VdBindShop.vue?vue&type=script&lang=ts"
import style0 from "./VdBindShop.vue?vue&type=style&index=0&id=b29add38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29add38",
  null
  
)

export default component.exports